import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  private webChatClickSubject = new Subject<void>();
  imageClick$ = this.webChatClickSubject.asObservable();

  emitWebChatClick() {
    this.webChatClickSubject.next();
  }
}
